import { AllowedCallTypes, CrudConfig } from "seneca-common/utils/apiStates";

export const PATH_TO_COURSE_ENROLLMENTS_STATE = "course-enrollments";

export const courseEnrollmentsCrudConfig: CrudConfig = Object.freeze({
  name: "enrollments",
  path: "seneca/enrollments/courses/meta",
  idFieldName: "courseId",
  callTypes: [
    AllowedCallTypes.FETCH_ALL,
    AllowedCallTypes.CREATE,
    AllowedCallTypes.DELETE
  ]
});
